export default {
  parameters: {
    landing_id: "IDeng",
  },
  downtimeUrl: "https://id.kodland.tech",
  startPage: {
    image: "/welcome/quiz_indo_coding_2.jpeg",
    title: "<div>Complete a 2-minute survey and get an invite to a FREE programming class.</div>",
    subtitle: "In this class, we will create a project with your child, and prove your child's computer time more useful.",
    button: "Get started 🚀",
  },
  successPage: {
    title: "Choose a date and time to get your FREE lesson 🚀",
    subtitle: "Click the “📆 Book” button and get the lesson",
    button: "📆 Book",
  },
  quizRotateBySteps: {
    1: {
      question: "Does your child take part in extracurricular activities outside of school learning?",
      answers: [
        "📚 Classes that help to improve learning scores", 
        "⛹️ Yes. Sports activities", 
        "🎨 Yes. Art classes", 
        "💻 Yes. Coding and computer science classes", 
        "🏕️ Yes. Scouts", 
        "✖️ No. Child doesn't have time for it", 
      ],
    },
    2: {
      question: "What is your child's favourite school subject?",
      answers: [
        "🔬 Science", 
        "🎨 Art and design", 
        "💻 Computer science", 
        "🏛️ Cultural studies", 
        "📐 Maths", 
        "💬 Language Sciences", 
        "🤩 All of the above", 
      ],
    },
    3: {
      question: "Do you want your child's time spent on the computer to be more productive?",
      answers: [
        "😍 Yes!", 
        "🙂 No. It's just for fun and that's fine. ", 
      ],
    },  
    4: {
      question: "Are you able to connect to the free trial class from a computer or laptop?",
      answers: [
        "💻 Yes", 
        "🙁 No",
      ],
    },
  },
};
